<div class="d-block w-100 bg-white px-4 py-3">
    <img src="./assets/media/msis/main-logo.png" width="300" />
</div>
